const initialState = {
  mdConcentrationData: [],
};

const mdConcentrationSlice = (set) => ({
  ...initialState,
  setMdConcentrationData: (mdConcentrationData) => set({ mdConcentrationData }),
  resetMdConcentrationData: () => set(initialState),
});

export default mdConcentrationSlice;
